(function () {
  function onReady(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  var SAVE_KEY = "mort-clothing-saved";

  function savedIds() {
    try {
      return JSON.parse(localStorage.getItem(SAVE_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  function writeSaved(ids) {
    localStorage.setItem(SAVE_KEY, JSON.stringify(ids));
  }

  function syncSave(btn, ids) {
    var id = String(btn.getAttribute("data-mort-save") || "");
    var on = ids.indexOf(id) !== -1;
    btn.classList.toggle("is-saved", on);
    btn.setAttribute("aria-pressed", on ? "true" : "false");
  }

  onReady(function () {
    var burger = document.querySelector("[data-mort-burger]");
    var mnav = document.querySelector("[data-mort-mnav]");
    if (burger && mnav) {
      burger.addEventListener("click", function () {
        var open = mnav.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    var header = document.querySelector(".mort-clothing-header");
    if (header && document.body.classList.contains("template-index")) {
      var onScroll = function () {
        header.classList.toggle("is-solid", window.scrollY > 48);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    document.querySelectorAll("[data-mort-acc]").forEach(function (btn) {
      var item = btn.closest(".mort-clothing-pdp__accitem, .mort-clothing-footer__col");
      var mark = btn.querySelector("[data-mort-accmark]");
      function sync() {
        var open = !!(item && item.classList.contains("is-open"));
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (mark) mark.textContent = open ? "–" : "+";
      }
      btn.addEventListener("click", function () {
        if (item) item.classList.toggle("is-open");
        sync();
      });
      sync();
    });

    function paintSavedUi(ids) {
      var countEl = document.querySelector("[data-mort-saved-count]");
      if (countEl) {
        countEl.textContent = String(ids.length);
        countEl.hidden = ids.length === 0;
      }
      document.querySelectorAll("[data-mort-saved-item]").forEach(function (item) {
        var id = String(item.getAttribute("data-mort-saved-item") || "");
        item.classList.toggle("is-hidden", ids.indexOf(id) === -1);
      });
      var empty = document.querySelector("[data-mort-saved-empty]");
      if (empty) empty.classList.toggle("is-hidden", ids.length > 0);
    }

    var ids = savedIds();
    document.querySelectorAll("[data-mort-save]").forEach(function (btn) {
      syncSave(btn, ids);
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var id = String(btn.getAttribute("data-mort-save") || "");
        var next = savedIds();
        var i = next.indexOf(id);
        if (i === -1) next.push(id);
        else next.splice(i, 1);
        writeSaved(next);
        document.querySelectorAll('[data-mort-save="' + id + '"]').forEach(function (other) {
          syncSave(other, next);
        });
        paintSavedUi(next);
      });
    });
    paintSavedUi(ids);

    document.querySelectorAll("[data-mort-pdp]").forEach(function (root) {
      initPdp(root);
      formatReviews(root);
    });
    document.querySelectorAll("[data-mort-collection]").forEach(initCollection);
  });

  function initPdp(root) {
    var form = root.querySelector("[data-mort-form]");
    var chart = root.querySelector("[data-mort-chart]");
    var openBtn = root.querySelector("[data-mort-chart-open]");
    var closeBtn = root.querySelector("[data-mort-chart-close]");
    if (openBtn && chart) {
      openBtn.addEventListener("click", function () {
        if (typeof chart.showModal === "function") chart.showModal();
      });
    }
    if (closeBtn && chart) {
      closeBtn.addEventListener("click", function () { chart.close(); });
    }
    if (chart) {
      chart.addEventListener("click", function (event) {
        if (event.target === chart) chart.close();
      });
    }

    if (!form) return;
    var idInput = form.querySelector("[data-mort-variant]");
    var atc = form.querySelector("[data-mort-atc]");
    var jsonEl = root.querySelector("[data-mort-variants]");
    var variants = [];
    try {
      variants = JSON.parse(jsonEl ? jsonEl.textContent : "[]");
    } catch (e) {
      variants = [];
    }

    var optionNames = [];
    root.querySelectorAll("[data-mort-option]").forEach(function (row) {
      optionNames.push(row.getAttribute("data-mort-option"));
    });

    function selectedValues() {
      return optionNames.map(function (name) {
        var checked = root.querySelector('[data-mort-option="' + name + '"] [aria-checked="true"]');
        return checked ? checked.getAttribute("data-value") : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) {
          return !val || v.options[i] === val;
        });
      });
    }

    function apply(variant) {
      if (!variant || !idInput) return;
      idInput.value = variant.id;
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available
          ? atc.getAttribute("data-label-default")
          : atc.getAttribute("data-label-soldout");
      }
      var stock = root.querySelector("[data-mort-stock]");
      if (stock) {
        var threshold = parseInt(stock.getAttribute("data-low-threshold") || "5", 10);
        var qty = variant.inventory_quantity;
        var state = "out";
        var label = stock.getAttribute("data-out") || "";
        if (variant.available) {
          if (qty != null && qty !== "" && !isNaN(Number(qty)) && Number(qty) > 0 && Number(qty) <= threshold) {
            state = "low";
            label = (stock.getAttribute("data-low") || "").replace(/\[qty\]/g, String(qty));
          } else {
            state = "in";
            label = stock.getAttribute("data-in") || "";
          }
        }
        stock.classList.remove("is-in", "is-low", "is-out");
        stock.classList.add("is-" + state);
        stock.textContent = label;
      }
    }

    root.querySelectorAll("[data-mort-size]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.getAttribute("aria-disabled") === "true") return;
        var row = btn.closest("[data-mort-option]");
        row.querySelectorAll("[data-mort-size]").forEach(function (other) {
          other.setAttribute("aria-checked", other === btn ? "true" : "false");
        });
        apply(findVariant(selectedValues()));
      });
    });

    var first = variants.find(function (v) { return v.available; }) || variants[0];
    if (first) {
      first.options.forEach(function (val, i) {
        var row = root.querySelectorAll("[data-mort-option]")[i];
        if (!row) return;
        row.querySelectorAll("[data-mort-size]").forEach(function (btn) {
          btn.setAttribute("aria-checked", btn.getAttribute("data-value") === val ? "true" : "false");
        });
      });
      apply(first);
    }
  }

  function formatReviews(root) {
    var widget = root.querySelector(".jdgm-rev-widg");
    var badge = root.querySelector(".jdgm-prev-badge");
    var source = widget || badge;
    if (!source) return;

    var count = Number(source.getAttribute("data-number-of-reviews") || 0);
    var avg = source.getAttribute("data-average-rating") || "";
    var avgDe = avg.replace(".", ",");
    var label = count === 1 ? "1 Bewertung" : count + " Bewertungen";

    var badgeText = root.querySelector(".jdgm-prev-badge__text");
    if (badgeText) badgeText.textContent = label;

    var summary = root.querySelector(".jdgm-rev-widg__summary-text");
    if (summary) {
      summary.textContent = avg ? avgDe + " von 5 · " + label : label;
    }

    var meta = root.querySelector("[data-mort-review-meta]");
    if (meta && count > 0) {
      meta.hidden = false;
      meta.textContent = avg ? avgDe + " von 5 Sternen · " + label : label;
    }

    // Judge.me lazy thumbs often stay on data-src when their script does not hydrate.
    root.querySelectorAll(".jdgm-rev__pic-img[data-src]").forEach(function (img) {
      var src = img.getAttribute("data-src");
      if (!src) return;
      if (!img.getAttribute("src")) img.setAttribute("src", src);
      img.addEventListener("error", function () {
        var wrap = img.closest(".jdgm-rev__pic, .jdgm-rev__pic-link") || img;
        wrap.style.display = "none";
      });
    });
  }

  function initCollection(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-mort-card]"));
    var colorBtns = Array.prototype.slice.call(root.querySelectorAll("[data-mort-color]"));
    var avail = root.querySelector("[data-mort-available]");
    var countEl = root.querySelector("[data-mort-count]");
    var color = "all";

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var okColor = color === "all" || card.getAttribute("data-color") === color;
        var okAvail = !avail || !avail.checked || card.getAttribute("data-available") === "true";
        var show = okColor && okAvail;
        card.classList.toggle("is-hidden", !show);
        if (show) visible += 1;
      });
      if (countEl) {
        countEl.textContent = visible === 1 ? "1 Produkt" : visible + " Produkte";
      }
    }

    colorBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        color = btn.getAttribute("data-mort-color") || "all";
        colorBtns.forEach(function (other) {
          other.classList.toggle("is-active", other === btn);
        });
        apply();
      });
    });
    if (avail) avail.addEventListener("change", apply);
  }
})();
